// =====================================================================
// Talk-track tips shown on the "calling in pool" waiting screen — rotated one
// at a time so an SDR waiting for the next call keeps a coaching prompt in view.
// The tip CONTENT ships as a static JSON file (tips.json) so it can be edited
// without touching code; the rotation timer lives in the component (cockpit.tsx
// RotatingTip), and the index math is here (framework-free, unit-tested).
// =====================================================================
import tipsJson from './tips.json';

// How often the visible tip advances. The PRD: rotate every 10 seconds.
export const TIP_ROTATION_MS = 10_000;

// The talk-track prompts under the call-resources link — sourced from tips.json.
export const WAITING_TIPS: readonly string[] = tipsJson;

// Next index in the rotation, wrapping at the end. Returns 0 for an empty list.
export function nextTipIndex(current: number, count: number): number {
  return count > 0 ? (current + 1) % count : 0;
}
